import React, { useState } from "react";
import style from "../../styles/instructionview";

import HighlightOff from "material-ui/svg-icons/action/highlight-off";

export default (props) => {
  const [fullScreen, setFullScreen] = useState(false);
  let controlStyle = !fullScreen
    ? { ...style.instructionImg, ...props.style }
    : style.instructionImgFullScreen;
  return (
    <div
      onClick={() => setFullScreen(!fullScreen)}
      style={{
        ...controlStyle,
        backgroundImage: `url(${props.url})`,
      }}
    >
      {fullScreen && (
        <div style={style.closeMsg}>
          Click to close <HighlightOff  />
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/InstructionPhoto.js